import { render } from "./ViewAllFeedback.vue?vue&type=template&id=2f517201"
import script from "./ViewAllFeedback.vue?vue&type=script&lang=js"
export * from "./ViewAllFeedback.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__